import React from 'react';
import { Facebook, Instagram, Linkedin, Youtube, MapPin, ExternalLink } from 'lucide-react';

export default function FooterPreview({ form = {} }) {
  const itemType = form.item_type || 'link';

  return (
    <div className="bg-slate-50 min-h-full flex flex-col font-sans">
      {/* Top Bar */}
      <div className="bg-white border-b px-4 py-2.5 flex flex-wrap items-center justify-between gap-2 text-xs">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-slate-500">Footer Item Type:</span>
          <span className="px-2 py-0.5 rounded bg-amber-100 text-amber-800 font-bold uppercase text-[10px]">
            {itemType}
          </span>
          {form.section && (
            <span className="px-2 py-0.5 rounded bg-slate-100 text-slate-700 text-[10px] font-mono">
              Column: {form.section}
            </span>
          )}
        </div>
        <div className="text-slate-400 text-[11px]">Order: #{form.display_order ?? 0}</div>
      </div>

      {/* Simulated Footer Canvas */}
      <div className="p-6 md:p-8 flex-1 flex flex-col justify-center">
        <div className="max-w-4xl mx-auto w-full bg-slate-900 text-white rounded-2xl p-8 shadow-2xl space-y-8">
          {/* Top CTA Row */}
          <div className="flex flex-wrap items-center justify-between gap-4 border-b border-slate-800 pb-6">
            <div>
              <span className="text-xl font-black tracking-wider text-white">ZOBOX</span>
              <p className="text-xs text-slate-400 mt-1">Refurbished electronics for everyone.</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <span className="px-4 py-2 rounded-lg bg-[#2B3380] text-white text-xs font-semibold">
                Open Support
              </span>
              <span className="px-4 py-2 rounded-lg bg-slate-800 text-white text-xs font-semibold border border-slate-700">
                Contact Us
              </span>
            </div>
          </div>

          {/* Highlighted current item banner */}
          <div className="bg-indigo-950/80 border border-indigo-500/40 rounded-xl p-4 text-xs space-y-1">
            <span className="text-indigo-300 font-bold uppercase text-[10px] block">
              Currently Editing Item ({itemType})
            </span>
            <div className="font-bold text-white text-sm">
              {form.title || form.label || form.copyright_text || 'Active Item'}
            </div>
            {form.url && <div className="text-indigo-200 font-mono text-[11px]">Target: {form.url}</div>}
            {form.address && <div className="text-slate-300">{form.address}</div>}
            {form.description && <div className="text-slate-300">{form.description}</div>}
          </div>

          {/* Simulated Columns Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-xs text-slate-400 border-b border-slate-800 pb-8">
            <div>
              <h4 className="font-bold text-white text-sm mb-3">Ecosystem</h4>
              <ul className="space-y-2">
                <li>Buy Mobile &amp; Laptop</li>
                <li>Sell Existing Device</li>
                <li>ZOBIZ Wholesale</li>
                <li>Franchise Opportunities</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white text-sm mb-3">Company</h4>
              <ul className="space-y-2">
                <li>About ZOBOX</li>
                <li>Stores &amp; Service</li>
                <li>ZOBOX Minutes</li>
                <li>Careers</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold text-white text-sm mb-3">Help &amp; Legal</h4>
              <ul className="space-y-2">
                <li>Support Center</li>
                <li>Warranty Policy</li>
                <li>Privacy Policy</li>
                <li>Terms of Use</li>
              </ul>
            </div>
            <div className="space-y-3">
              <h4 className="font-bold text-white text-sm">Offices</h4>
              <div className="text-[11px] leading-relaxed">
                <strong className="text-slate-300 block">Corporate Office:</strong>
                <span>E218C, Sector 63, Noida, UP 201301</span>
              </div>
              <div className="flex gap-2 text-white pt-1">
                <Facebook className="w-4 h-4 text-slate-400 hover:text-white" />
                <Instagram className="w-4 h-4 text-slate-400 hover:text-white" />
                <Linkedin className="w-4 h-4 text-slate-400 hover:text-white" />
                <Youtube className="w-4 h-4 text-slate-400 hover:text-white" />
              </div>
            </div>
          </div>

          {/* Disclaimer & Copyright */}
          <div className="text-[11px] text-slate-500 flex flex-wrap items-center justify-between gap-2">
            <p>{form.item_type === 'meta' && form.description ? form.description : 'ZOBOX employees will never ask for your OTP over phone or email.'}</p>
            <p>{form.copyright_text || `© ${new Date().getFullYear()} Zobox Protech Limited. All rights reserved.`}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
